var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 7.99984C1.33301 5.88275 3.04925 4.1665 5.16634 4.1665C6.62006 4.1665 7.88384 4.97564 8.53354 6.1665H14.4997C15.144 6.1665 15.6663 6.68884 15.6663 7.33317V8.99984C15.6663 9.27598 15.4425 9.49984 15.1663 9.49984H13.6663V10.6665C13.6663 10.9426 13.4425 11.1665 13.1663 11.1665H11.4997C11.2235 11.1665 10.9997 10.9426 10.9997 10.6665V9.49984H8.69493C8.11127 10.8711 6.75172 11.8332 5.16634 11.8332C3.04925 11.8332 1.33301 10.1169 1.33301 7.99984ZM5.16634 6.6665C4.42996 6.6665 3.83301 7.26346 3.83301 7.99984C3.83301 8.73622 4.42996 9.33317 5.16634 9.33317C5.90272 9.33317 6.49967 8.73622 6.49967 7.99984C6.49967 7.26346 5.90272 6.6665 5.16634 6.6665Z",
    fill: "#0E46C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.1acc9ac71cb1ff248a2d60629ff89959.svg";
export { ForwardRef as ReactComponent };